<template>
    <div class="container-fluid px-0">

        <AuthNav></AuthNav>

        <NavButtons light-btns></NavButtons>

    </div>
    <div class="row">
        <div v-if="!passwordLinkSent" ref="forgotPasswordForm" class="col-sm-8 offset-sm-2 col-md-6 offset-md-3 col-xl-4 offset-xl-4 mb-3">
            <div class="d-flex flex-column gap-3 text-center mb-5">
                <h3 class="fw-semi-bold m-0">Forgot Password</h3>
                <p class="text-secondary m-0">Please enter your email address to receive a link to reset your account's Password</p>
            </div>
            <div class="d-flex align-items-center justify-content-between rounded-pill border py-2 px-3 input-container border-active-darken my-3" :class="formErrors.email ? 'border-danger' : 'border-secondary'">
                <label for="email">
                    <i class="me-3 dd-icon bi bi-envelope-at"></i>
                </label>
                <input v-model="email" @input="removeFormErrorKey('email')" type="text" id="email" name="email" class="form-control m-0 border-0 fs-5 p-0 lh-fixed" placeholder="Email Address" >
            </div>
            <div v-if="formErrors.email" class="validation-error" v-html="formErrors.email"></div>

            <div class="d-flex flex-column align-items-center justify-content-between text-center mt-3">
                <button class="btn btn-dark rounded-pill d-flex align-items-center justify-content-center py-2 px-3 w-50" @click="forgotPassword" >
                    Send Link <i class="bi bi-arrow-right"></i>
                </button>
                <div class="mt-3">
                    <span class="text-secondary">You remember your password? Back to </span>
                    <a v-load-page="'/login'" class="text-primary cursor-pointer">Login</a>
                </div>
            </div>
        </div>
        <div v-else class="col-sm-8 offset-sm-2 col-md-6 offset-md-3 col-xl-4 offset-xl-4 mb-3">
            <div class="d-flex flex-column gap-3 text-center mb-5">
                <h3 class="fw-semi-bold m-0">Reset Link Sent!</h3>
                <p class="text-secondary m-0" v-html="responseMessage"></p>
            </div>
        </div>

    </div>

</template>

<script setup>
import {computed, onMounted, ref} from "vue";
import {useAuthStore} from "@/stores/auth-store";
import {useAppHelpers} from "@/composables/useAppHelpers";
import {useHttpErrorManager} from "@/composables/useHttpErrorManager";
import NavButtons from "@/components/NavButtons.vue";
import AuthNav from "@/views/Auth/AuthNav.vue";
import apiClient from "@/utils/axios";
import {useRouter} from "vue-router";

const helper = useAppHelpers();
const auth = useAuthStore();
const router = useRouter();

const forgotPasswordForm = ref(null);
const passwordLinkSent = ref(false);
const responseMessage = ref('');

const email = ref('');
const formErrors = ref({});

const forgotPassword = async () => {
    helper.loaderOn(forgotPasswordForm.value);
    if (!email.value) {
        formErrors.value.email = 'Please enter your Email Address.';
        helper.loaderOff(forgotPasswordForm.value);
        return;
    }

    removeFormErrorKey('email');

    try {
        const response = await apiClient.post('/forgot-password', {
            email: email.value
        });
        helper.loaderOff(forgotPasswordForm.value);
        if(response.status === 200){
            responseMessage.value = response.data.message;
            passwordLinkSent.value = true;
        }
    } catch (error) {
        helper.loaderOff(forgotPasswordForm.value);
        let errorObj = await useHttpErrorManager().handleError(error);
        if (error.response.status === 422) {
            formErrors.value = errorObj;
	        removeFormErrorKey('full_message');
            removeFormErrorKey('alt_message');
            removeFormErrorKey('err_message');
        }
        // helper.toast(error.response.data.message, 'error');
    }
};

const removeFormErrorKey = (key) => {
    delete formErrors.value[key];
};

const hasFormErrors = computed(() => {
    return Object.keys(formErrors.value).length > 0;
});

onMounted(() => {

});

</script>

<style scoped lang="scss"></style>
